import React, { useState, useEffect } from "react";
import axiosInstance from "../../services/axiosInstance";
import { catchError } from "../../utils/errorHandler";
import { useParams } from "react-router-dom";
import {
  Modal,
  Checkbox,
  List,
  Spin,
  Button,
  message,
  Flex,
  Typography,
  Card,
  Tag,
  Table,
} from "antd";
import orderService from "../../services/OrderLists";
import { WarningOutlined } from "@ant-design/icons";


function MarkAsDone({ isVisible, setIsModalVisible, feedbackKey, getFeedBack, selectedUid }) {
  const { Title, Text } = Typography;
  const { orderKey } = useParams();
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [feedBackReport, setFeedBackReport] = useState([]);

  const fetchSubscribersList = async () => {
    setIsLoading(true);
    try {
      const res = await axiosInstance.get(
        `task/v2/task-subscribers-list/${orderKey}/`
      );
      const data = res?.data?.data || [];
      if (data) setIsLoading(false);
      setDataSource(data);
    } catch (err) {
      console.error("Failed to load subscriber list:", err);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const getFeedBackReportScrore = async () => {
    try {
      const res = await axiosInstance.get(
        `/task/v2/feedback-report-score/${selectedUid}/`
      );
      if (res.status && res.data.status) {
        const data = res?.data?.data || [];
        setIsLoading(false);
        setFeedBackReport(data);
      }
    } catch (err) {
      console.log("err", err)
    }
  }

  // console.log("feedBackReport", feedBackReport)

  useEffect(() => {
    fetchSubscribersList();
    getFeedBackReportScrore()
  }, [orderKey]);

  const handleUserSelect = (uuid) => {
    setSelectedUsers((prev) =>
      prev.includes(uuid) ? prev.filter((id) => id !== uuid) : [...prev, uuid]
    );
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const selectedUsernames = dataSource
        .filter((item) => selectedUsers.includes(item.uuid))
        .map((item) => item.username);

      const response = await orderService.markAsDone(feedbackKey, {
        subscribers: selectedUsernames,
      });

      if (response.success) {
        message.success("Successfully marked as verified");
        await getFeedBack("4")
        setIsLoading(false);

        setIsModalVisible(false); // Close modal after successful action
      } else {
        message.error("Failed to mark as verified");
      }
    } catch (err) {
      setIsLoading(false);

      message.error("An error occurred");
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}>
        <Spin size="large" />
      </div>
    );
  }

  const MyComponent = ({ data }) => {
    if (!data?.visible) return null;

    const columns = [
      {
        dataIndex: "label",
        key: "label",
        render: (text) => (
          <Text strong style={{ fontSize: 13, color: "#1d1d1d", }}>
            {text}
          </Text>
        ),
      },
      {
        dataIndex: "value",
        key: "value",
        render: (value, record) => {
          if (record.label === "Quality") {
            return (
              <Tag
                color={data?.color}
                style={{
                  padding: "4px 10px",
                  fontSize: 13,
                  fontWeight: 500,
                  borderRadius: 4,
                  textTransform: "capitalize",
                  border: "none",
                }}
              >
                {value}
              </Tag>
            );
          }
          return (
            <Text strong style={{ padding: "4px 10px", fontSize: 14, color: "#1d1d1d" }}>
              {value}
            </Text>
          );
        },
      },
    ];


    const tableData = [
      {
        key: "1",
        label: "Average Evaluation Score",
        value: data?.average_evaluation_score || "-",
      },
      {
        key: "2",
        label: "Quality",
        value: data?.status || "-",
      },
    ];

    return (
      <Card
        bordered={false}
        style={{
          backgroundColor: "#fffaf2",
          border: "1px solid #ffe8c5",
          borderRadius: 12,
          width: "100%",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
          overflow: "hidden",
        }}
        bodyStyle={{ padding: "0px" }}
      >
        <div style={{ padding: "16px 20px" }}>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
            }}
          >
            <WarningOutlined style={{ color: "#faad14", fontSize: 18 }} />
            <Text strong style={{ fontSize: 15, color: "#1d1d1d" }}>
              AI Evaluation for Feedback
            </Text>
          </div>

          <Table
            columns={columns}
            dataSource={tableData}
            pagination={false}
            showHeader={false}
            bordered={false}
            size="small"
            style={{ marginTop: 8 }}
          />

        </div>
      </Card>
    );
  };

  return (
    <Modal
      maskClosable={false}
      loading={isLoading}
      className="custom-modal2"
      title={
        <Flex justify="space-between" className="custom-modal-header">
          <Title
            level={3}
            style={{
              color: "white",
              margin: 0,
              position: "relative",
              marginLeft: "10px",
            }}>
            Mark As Done
          </Title>
        </Flex>
      }
      visible={isVisible}
      onCancel={setIsModalVisible} // Ensures modal closes on cancel
      footer={
        <Flex style={{ width: "100%" }} justify="flex-end" align="flex-end">
          <Button loading={isLoading} type="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Flex>
      }>

      <MyComponent data={feedBackReport} />
      <h2>Are you sure to move this order for the next step?</h2>

      {dataSource?.length > 0 && <List
        style={{
          maxHeight: "300px",
          overflowX: "hidden",
          overflowY: "auto",
        }}
        dataSource={dataSource}
        renderItem={(item) => (
          <List.Item>
            <Checkbox
              checked={selectedUsers.includes(item.uuid)}
              onChange={() => handleUserSelect(item.uuid)}>
              {item.subscriber} ({item.type})
            </Checkbox>
          </List.Item>
        )}
      />}

    </Modal>
  );
}

export default MarkAsDone;
